var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 68,
    height: 68,
    rx: 5,
    stroke: "#6466E9",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 49,
    height: 45,
    rx: 4,
    fill: "#E4EDF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 26C30.0296 26 26 30.0296 26 35C26 39.9704 30.0296 44 35 44C39.9704 44 44 39.9704 44 35C44 30.0296 39.9704 26 35 26ZM33.7913 38.6974C33.5289 38.9696 33.1997 39.1683 32.8365 39.2736C32.1302 39.4757 31.4232 39.6768 30.7194 39.8874C30.5295 39.9444 30.365 39.938 30.2188 39.7988C30.0637 39.6512 30.0518 39.4768 30.1108 39.2789C30.3309 38.5406 30.5288 37.7963 30.7679 37.064C30.8495 36.8151 30.9869 36.5578 31.1683 36.3729C32.6262 34.8857 35.6486 31.8623 35.6486 31.8623L38.1289 34.3461L38.1338 34.351C38.1338 34.351 35.1793 37.3024 33.7913 38.6974ZM39.5823 32.9068L38.6211 33.8683L36.1324 31.3789L37.0939 30.4174C37.3115 30.2 37.6064 30.0779 37.9139 30.0779C38.2215 30.0779 38.5164 30.2 38.7339 30.4174L39.5823 31.2657C39.6901 31.3734 39.7756 31.5014 39.8339 31.6422C39.8922 31.7829 39.9223 31.9339 39.9223 32.0862C39.9223 32.2386 39.8922 32.3896 39.8339 32.5303C39.7756 32.6711 39.6901 32.7991 39.5823 32.9068Z",
    fill: "#6466E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualEnter);
export default __webpack_public_path__ + "static/media/manual-enter.ffd746a1.svg";
export { ForwardRef as ReactComponent };